import {
  Box,
  List,
  Slide,
  Drawer,
  Hidden,
  Button,
  Dialog,
  Typography,
  ListSubheader,
  DialogActions,
  DialogContent,
} from "@mui/material";
import NavItem from "./NavItem";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import { NAV_BAR_STYLING } from "../styles";
import { ACROSS_LOGO } from "../../../assets";
import React, { useEffect, useState } from "react";
import TypeWrapper from "../../../utils/TypeWrapper";
import PerfectScrollbar from "react-perfect-scrollbar";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { getLanguage } from "../../../utils/localization";
import { useLocation, useNavigate } from "react-router-dom";
import { CLEAR_REDUX_STATE } from "../../../store/clearstore";
import { ExitToApp as ExitToAppIcon } from "@mui/icons-material";
import GlobalExpandNavItem from "../../../components/GlobalExpandNavItem/GlobalExpandNavItem";

const VENDOR_SECTION = [
  {
    items: [
      {
        title: "Dashboard",
        icon: DashboardIcon,
        href: "/admin-dashboard",
      },
    ],
  },
];

const useStyles = makeStyles((theme) => ({
  toolbar: {
    background: TypeWrapper.COLORS.HX_WHITE,
    boxShadow: "0px 0px 53px rgba(0, 0, 0, 0.25)",
    [theme.breakpoints.down("md")]: {},
  },
  logo: {
    marginRight: theme.spacing(2),
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    "& + &": {
      marginLeft: theme.spacing(2),
    },
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  mainheader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",

    "& svg": {
      color: theme.palette.text.primary,
    },
    "& .leftBox": {
      width: "306px",
      [theme.breakpoints.down("md")]: {
        width: "200px",
      },
      [theme.breakpoints.down("xs")]: {
        width: "150px",
      },
      "& img": {
        width: "150px",
        [theme.breakpoints.down("xs")]: {
          width: "104px",
          paddingLeft: "0 !important",
        },
      },
    },
  },
  menuPaper: {
    backgroundColor: TypeWrapper.COLORS.HX_WHITE,
  },
}));

function renderNavItems({ items, pathname, depth }) {
  return (
    <List disablePadding>
      {items?.map((item, index) =>
        item?.isAccordion ? (
          <GlobalExpandNavItem key={index} item={item} />
        ) : (
          <NavItem
            key={index}
            href={item?.href}
            icon={item?.icon}
            title={item?.title}
          />
        )
      )}
    </List>
  );
}

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLogout, setIsLogout] = useState(false);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location?.pathname]);

  const onLogout = async () => {
    dispatch(CLEAR_REDUX_STATE.CLEAR_LOGIN_DETAILS());
    toast.success("Logout successful!");
    navigate("/admin-signin");
  };

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const content = (
    <Box
      sx={NAV_BAR_STYLING.BOX_CNTNR}
      style={{ marginTop: openMobile ? 20 : 90, width: 240 }}
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box pt={2} pb={0}>
          <Box className="sideMenuBox" sx={NAV_BAR_STYLING.SDE_MNU_BX}>
            <Hidden mdUp>
              <Box style={NAV_BAR_STYLING.LG_BX}>
                <img
                  alt="Logo"
                  src={ACROSS_LOGO}
                  style={{
                    width: 200,
                    marginTop: 0,
                    marginLeft: 20,
                  }}
                />
              </Box>
            </Hidden>
            <>
              {VENDOR_SECTION?.map((section, i) => (
                <List
                  key={`menu${i}`}
                  subheader={
                    <ListSubheader disableGutters disableSticky>
                      {section.subheader}
                    </ListSubheader>
                  }
                >
                  {renderNavItems({
                    items: section.items,
                    pathname: location?.pathname,
                  })}
                </List>
              ))}
            </>
          </Box>
        </Box>

        {/* ****** Logout Button Container ****** */}
        <Box
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => setIsLogout(true)}
            sx={{
              height: 45,
              bottom: 25,
              width: "90%",
              display: "flex",
              borderRadius: "6px",
              alignItems: "center",
              position: "absolute",
              backgroundColor: TypeWrapper.COLORS.RED,
              justifyContent: "center",
              "&:hover": {
                color: TypeWrapper.COLORS.HX_WHITE,
                backgroundColor: TypeWrapper.COLORS.NAV_BAR,
              },
            }}
          >
            <ExitToAppIcon
              sx={{ color: TypeWrapper.COLORS.HX_WHITE, fontSize: 30 }}
            />
            &nbsp;
            <Typography
              variant="body"
              sx={{
                fontWeight: "600",
                marginLeft: 1,
                color: TypeWrapper.COLORS.HX_WHITE,
                fontFamily: "'Poppins', sans-serif",
              }}
            >
              {getLanguage("LOGUT.LGT")}
            </Typography>
          </Button>
        </Box>

        {/* ****** Sidebar Logout PopUp Container ****** */}
        {isLogout && (
          <Dialog
            fullWidth
            maxWidth="xs" // Adjust the dialog width for smaller screens
            open={isLogout}
            className={classes.dailogOpen}
            TransitionComponent={Transition}
            onClose={(event, reason) => {
              if (reason === "backdropClick" || reason === "escapeKeyDown") {
                return; // Prevent dialog from closing
              }
              setIsLogout(false);
            }}
            BackdropProps={{
              style: { pointerEvents: "none" },
            }}
            sx={{
              "& .MuiDialog-paper": {
                margin: 1,
                padding: 1,
                borderRadius: "4px",
                backgroundColor: TypeWrapper.COLORS.HX_WHITE,
              },
            }}
          >
            <Box className="newModalBorder">
              <Box
                style={{
                  padding: 2,
                  backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                }}
                className="mainbox1"
              >
                <DialogContent>
                  <Box className={classes.dialougTitle} align="center">
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: "500",
                        marginBottom: "8px",
                        color: TypeWrapper.COLORS.BLACK,
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {getLanguage("LOGUT.LGT")}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{
                        fontSize: 16,
                        color: TypeWrapper.COLORS.BLACK,
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {getLanguage("LOGUT.LGT_LBL")}
                    </Typography>
                  </Box>
                </DialogContent>
                <DialogActions
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" }, // Stack buttons vertically on small screens
                    gap: 1, // Add spacing between buttons
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      width: { xs: "100%", sm: 120 },
                      padding: 1.5,
                      borderRadius: 30,
                      fontWeight: "600",
                      textTransform: "none",
                      color: TypeWrapper.COLORS.HX_WHITE,
                      fontFamily: "'Poppins', sans-serif",
                      backgroundColor: TypeWrapper.COLORS.BTN_THEME,
                    }}
                    onClick={() => onLogout()}
                  >
                    {getLanguage("LOGUT.LGT_CFRM")}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      width: { xs: "100%", sm: 120 },
                      padding: 1.5,
                      borderRadius: 30,
                      fontWeight: "600",
                      textTransform: "none",
                      color: TypeWrapper.COLORS.BLACK,
                      fontFamily: "'Poppins', sans-serif",
                      backgroundColor: TypeWrapper.COLORS.HX_WHITE,
                    }}
                    onClick={() => setIsLogout(false)}
                  >
                    {getLanguage("LOGUT.LGT_CNCL")}
                  </Button>
                </DialogActions>
              </Box>
            </Box>
          </Dialog>
        )}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden mdUp>
        <Drawer
          anchor="left"
          open={openMobile}
          variant="temporary"
          onClose={onMobileClose}
          sx={{
            // width: "100%", // Full width for small devices
            width: "29vw",
            flexShrink: 0,
            backgroundColor: TypeWrapper.COLORS.HX_WHITE,
          }}
        >
          <Box
            p={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            style={{ backgroundColor: TypeWrapper.COLORS.HX_WHITE }}
          >
            <img
              alt="Logo"
              style={{ width: 110, marginLeft: 10 }}
              src={ACROSS_LOGO}
            />
            <Button
              onClick={onMobileClose}
              sx={{ color: TypeWrapper.COLORS.BLACK }}
            >
              X {/* Replace with an icon from Material UI if preferred */}
            </Button>
          </Box>
          <Box
            sx={{
              flex: 1,
              paddingTop: "0px",
              backgroundColor: TypeWrapper.COLORS.HX_WHITE,
            }}
          >
            {content}
          </Box>
        </Drawer>
      </Hidden>

      <Hidden mdDown>
        <Drawer
          open
          anchor="left"
          variant="persistent"
          sx={{
            width: 240,
            height: "100%",
            marginTop: 10.8,
            backgroundColor: TypeWrapper.COLORS.HX_WHITE,
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
